// utils/IdleLogoutManager.js
import { performLogout } from "./utils";
let idleTimer = null;
const events = ['mousemove', 'keydown', 'mousedown', 'scroll', 'touchstart'];
const IDLE_TIMEOUT = 30 * 60 * 1000; // 10 minutes

const resetTimer = () => {
  clearTimeout(idleTimer);
  idleTimer = setTimeout(() => {
    console.log('Idle for 10 minutes, logging out...');
    performLogout();
  }, IDLE_TIMEOUT);
};

export const startIdleListener = () => {
  events.forEach(event => window.addEventListener(event, resetTimer));
  resetTimer(); // init on load
};

export const stopIdleListener = () => {
  events.forEach(event => window.removeEventListener(event, resetTimer));
  clearTimeout(idleTimer);
};
